module.exports = __webpack_public_path__ + "static/media/microphone.63fc25c2.svg";